import { Col, Row, Spin } from "antd";
import useInfiniteScroll from "react-infinite-scroll-hook";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import VideoIcon from "../../../assets/icons/jouer.svg";
import LockIcon from "../../../assets/icons/lock-outlined-without-point.svg";
import FeedMediaComponent from "../../../components/MediaComponent/FeedMediaComponent";
import NoPublicationComponent from "../../../components/NoPublicationComponent";
import SpinnerComponent from "../../../components/SpinnerComponent/SpinnerComponent";
import { FILE_STATUS, LIMIT_PER_PAGE, REQUEST_LOADING_STATES, THUMBNAIL_TYPES } from "../../../helpers/constant";
import useFetchFeeds from "../../../hooks/feedHooks/useFetchFeeds";
import { getOtherUserFeedsById } from "../../../redux/feeds/feedsSlice";
import { AppDispatch } from "../../../redux/store";

interface Props {
  isMyProfile: boolean;
  subscribed: boolean;
  creatorId: string;
}

export default function FeedGridComponent({ isMyProfile, creatorId, subscribed }: Props) {
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();

  const { loading, feeds } = useFetchFeeds(creatorId, isMyProfile);

  const loadMoreFeed = () => {
    if (feeds && feeds.hasMore && creatorId !== "") {
      dispatch(getOtherUserFeedsById({ creatorId, offset: feeds.offset, limit: LIMIT_PER_PAGE }));
    }
  };

  const [sentryRef] = useInfiniteScroll({
    loading: loading === REQUEST_LOADING_STATES.PENDING,
    hasNextPage: feeds?.hasMore || false,
    onLoadMore: loadMoreFeed,
  });

  const handleCreatePublication = () => {
    if (isMyProfile) {
      navigate("/creator/publication");
    }
  };

  return (
    <>
      {(!feeds || feeds?.feeds.length === 0) && !feeds?.hasMore && loading === REQUEST_LOADING_STATES.PENDING && <SpinnerComponent />}

      {feeds?.feeds.length === 0 ? (
        <div onClick={handleCreatePublication}>
          <NoPublicationComponent />
        </div>
      ) : (
        <Row className="mt-10 pr-4 pl-4" gutter={2}>
          {feeds?.feeds.map((feed) => {
            if (feed.files) {
              const lock = isMyProfile ? feed.isPrivate : feed.isPrivateForCurrentUser;
              const isVideo = feed.type === "video";
              const isUploading: boolean = feed.files[0].status === FILE_STATUS.UPLOADING;
              const feedThumbnail = isUploading
                ? ""
                : isVideo
                  ? feed.isPrivateForCurrentUser
                    ? feed.files[0].thumbnails?.find((thumb) => thumb.type === THUMBNAIL_TYPES.BLURRED)?.absolutePath
                    : feed.files[0].thumbnails?.find((thumb) => thumb.type === THUMBNAIL_TYPES.CLEAR)?.absolutePath
                  : feed.isPrivateForCurrentUser
                    ? feed.files[0].thumbnails?.find((thumb) => thumb.type === THUMBNAIL_TYPES.BLURRED)?.absolutePath
                    : feed.files[0].thumbnails?.findIndex((thumb) => thumb.type === THUMBNAIL_TYPES.CLEAR) !== -1
                      ? feed.files[0].thumbnails?.find((thumb) => thumb.type === THUMBNAIL_TYPES.CLEAR)?.absolutePath
                      : feed.files[0].url;

              return isUploading && !isMyProfile ? (
                <></>
              ) : (
                <Col
                  className="fanProfilePostWrapper"
                  key={feed._id}
                  span={8}
                  onClick={() => {
                    navigate(`/common/publications/${feed._id}/${creatorId}?isMyProfile=${isMyProfile}`);
                  }}
                >
                  <FeedMediaComponent
                    shouldAddWatermark={!isMyProfile!}
                    description=""
                    fileUrl={feedThumbnail!}
                    thumbnail=""
                    type="image"
                    imageClassName={`fanProfilePost ${!isMyProfile && lock ? "fanProfilePrivatePost" : ""}`}
                    isPrivate={feed.isPrivateForCurrentUser!}
                    isMyProfile={isMyProfile!}
                  />
                  {lock && <img className="fanProfilePostLockIcon" src={LockIcon} alt="lock" />}
                  {isVideo && <img src={VideoIcon} style={!lock ? { right: "11px" } : {}} alt="video icon" className="feedVideoIcon" />}
                  <Spin spinning={isUploading} className="feedSpinner" indicator={<SpinnerComponent />} />
                </Col>
              );
            }

            return <></>;
          })}
        </Row>
      )}
      {feeds?.hasMore && <SpinnerComponent refProp={sentryRef} />}
    </>
  );
}
